


















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'MissionCheckIcon',
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
  },
})
